import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { Radio } from '@crehana/compass.ui';
import { LANGUAGE_COOKIE } from '@crehana/constants';
import { cookies } from '@crehana/utils';
import clsx from 'clsx';
import { useFeatureFlagByNameKey } from "../../../../../hooks/useFeatureFlagByNameKey";
import Subtitle from "../Subtitle";
import { useTranslation } from "./hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var createLanguageChangeUrl = function createLanguageChangeUrl() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'es';
  return "/proxy/api/language/change/?language=".concat(language, "&next=").concat(window.location.pathname);
};
export var LanguageSelector = function LanguageSelector(_ref) {
  var isSupplanting = _ref.isSupplanting;
  var _useFeatureFlagByName = useFeatureFlagByNameKey({
      nameKey: 'USER_SELECT_LANGUAGE'
    }),
    enabled = _useFeatureFlagByName.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = [{
    value: 'es',
    label: t('SPANISH'),
    url: createLanguageChangeUrl('es')
  }, {
    value: 'pt',
    label: t('PORTUGUESE'),
    url: createLanguageChangeUrl('pt')
  }, {
    value: 'en',
    label: 'English',
    url: createLanguageChangeUrl('en')
  }];
  var _useState = useState(function () {
      // cookies.get will return an empty object if the cookie doesn't exists
      var langCookie = cookies.getCookie(LANGUAGE_COOKIE)[LANGUAGE_COOKIE];
      if (langCookie) {
        return options.find(function (opt) {
          return opt.value === langCookie.toLowerCase();
        });
      }
      return options.find(function (o) {
        return o.value === 'es';
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!enabled) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('tw-w-full tw-mt-2 tw-pt-2', 'tw-border-solid tw-border-t dark:tw-border-t-neutral-dark-700', isSupplanting ? 'tw-border-t-neutral-dark-300' : 'tw-border-t-neutral-light-300'),
    children: [/*#__PURE__*/_jsx(Subtitle, {
      label: t('PROFILE_LANGUAGE'),
      className: "tw-px-0.8"
    }), /*#__PURE__*/_jsx("ul", {
      className: "tw-flex tw-flex-col tw-items-start",
      children: options.map(function (option, index) {
        return /*#__PURE__*/_jsx(Radio, {
          className: "".concat(index !== 0 ? 'tw-mt-1.2' : '', " tw-gap-0.8 tw-px-0.8"),
          size: "s",
          onChange: function onChange() {
            if (option.value !== selectedOption.value) {
              setSelectedOption(option);
              window.location.href = option.url;
            }
          },
          checked: selectedOption.value === option.value,
          title: option.label
        }, option.value);
      })
    })]
  });
};
export default LanguageSelector;